import { RulesView } from './Rules.view'

export const Rules = () => <RulesView />
